module.exports = __WEBPACK_EXTERNAL_MODULE_22__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 22
// module chunks = 0 1